import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ResourcesSection() {
  const { t } = useTranslation();

  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-24">
      <div className="mx-auto max-w-2xl text-center">
        <span className="text-xs font-bold tracking-widest text-primary-600">{t('resources_eyebrow')}</span>
        <h2 className="mt-3 font-heading text-2xl font-semibold text-foreground-950 md:text-4xl">
          {t('resources_title')}
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{t('resources_subtitle')}</p>
      </div>

      <div className="mx-auto mt-10 max-w-3xl">
        <Link
          to="/article/usfans-spreadsheet-guide"
          className="group block overflow-hidden rounded-lg border border-background-200/70 bg-white transition-all hover:border-primary-300 cursor-pointer"
        >
          <div className="grid grid-cols-1 sm:grid-cols-5">
            <div className="sm:col-span-2">
              <div className="relative h-48 w-full overflow-hidden sm:h-full">
                <img
                  src="https://readdy.ai/api/search-image?query=Neat%20flat%20lay%20of%20a%20printed%20shopping%20checklist%20with%20sneaker%20hoodie%20and%20accessory%20product%20cards%20on%20a%20warm%20neutral%20background%20minimal%20editorial%20style%20soft%20light%20high%20detail&width=640&height=480&seq=usfans-article-02&orientation=landscape"
                  alt={t('article_card_title')}
                  title={`${t('article_card_title')} USFans Spreadsheet`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
            </div>
            <div className="flex flex-col justify-center p-6 sm:col-span-3 md:p-8">
              <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
                <span className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-file-list-3-line" />
                </span>
                {t('read_guide')}
              </span>
              <h3 className="mt-4 font-heading text-xl font-semibold text-foreground-950 md:text-2xl">
                {t('article_card_title')}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{t('article_card_desc')}</p>
              <span className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-primary-600">
                {t('read_more')}
                <span className="w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-1">
                  <i className="ri-arrow-right-line" />
                </span>
              </span>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
}